module.exports = __webpack_public_path__ + "img/Happiness_Rate_24@2x.de6f403b.png";